const AWSResources = [
  {
    aws_resource_name: process.env.VUE_APP_CUSTOMER_POOL_RESOURCE_NAME,
    identityPoolId: process.env.VUE_APP_IDENTITY_POOL_ID,
    region: process.env.VUE_APP_AWS_REGION,
    userPoolId: process.env.VUE_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.VUE_APP_USER_POOL_WEB_CLIENT_ID,
    mandatorySignIn: false,
    // clientMetadata: { app: 'underwriting' },
  },

  {
    aws_resource_name: process.env.VUE_APP_AGENT_POOL_RESOURCE_NAME,
    identityPoolId: process.env.VUE_APP_AGENT_IDENTITY_POOL_ID,
    region: process.env.VUE_APP_AWS_REGION,
    userPoolId: process.env.VUE_APP_AGENT_USER_POOL_ID,
    userPoolWebClientId: process.env.VUE_APP_AGENT_USER_POOL_WEB_CLIENT_ID,
    mandatorySignIn: false,
  },
];
export default AWSResources;
